interface BreadCrumb {
    label: string;
    uri: string;
}

const getBreadcrumbSchema = (
    canonicalPath: string,
    breadcrumbs?: BreadCrumb[]
) => {
    if (!breadcrumbs || breadcrumbs.length === 0) return undefined;

    const breadcrumbItems = breadcrumbs.map((breadcrumb, index) => {
        return {
            position: index + 1,
            item: {
                name: breadcrumb.label,
                '@id': `https://www.zoopla.co.uk${
                    breadcrumb.uri || canonicalPath
                }`
            },
            '@type': 'ListItem'
        };
    });

    return {
        itemListElement: breadcrumbItems,
        '@type': 'BreadcrumbList'
    };
};

export const useSchema = (
    breadcrumbs: { href: string; text: string }[],
    canonicalPath: string
) => {
    const breadcrumbItems = breadcrumbs.map((bc) => ({
        uri: bc.href,
        label: bc.text
    }));

    return () =>
        JSON.stringify(
            {
                '@context': 'http://schema.org',
                '@graph': [
                    {
                        alternateName: 'Zoopla Property Search',
                        '@context': 'http://schema.org',
                        url: `https://www.zoopla.co.uk${canonicalPath || ''}`,
                        name: 'Zoopla',
                        '@type': 'WebSite'
                    },
                    {
                        '@context': 'http://schema.org',
                        breadcrumb: getBreadcrumbSchema(
                            canonicalPath,
                            breadcrumbItems
                        ),
                        id: `https://www.zoopla.co.uk${canonicalPath}`,
                        '@type': 'WebPage'
                    }
                ]
            },
            null,
            '\t'
        );
};
